import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
interface FAQSectionProps {
  onCheckout: () => void;
}
export function FAQSection({
  onCheckout
}: FAQSectionProps) {
  const faqs = [{
    q: '¿Necesito saber programar o ser técnico?',
    a: 'No. Las skills funcionan con copiar y pegar. Abrís Claude, pegás las instrucciones, y listo. Si sabés usar WhatsApp, sabés usar esto.'
  }, {
    q: '¿Funciona solo con Claude o también con ChatGPT?',
    a: 'Está diseñado para Claude (claude.ai), que es la IA que mejores resultados da con instrucciones detalladas. Se pueden adaptar a otras IAs, pero los mejores resultados son con Claude.'
  }, {
    q: '¿Necesito pagar Claude aparte?',
    a: 'Claude tiene un plan gratuito que funciona para probar las skills. Para uso intensivo, el plan Pro cuesta aproximadamente $20 USD/mes. InfoSkills Pro no incluye la suscripción a Claude.'
  }, {
    q: '¿Sirve si recién empiezo con infoproductos?',
    a: 'Está diseñado para personas que ya venden o tienen un infoproducto en desarrollo. Si ya tenés un tema o una idea clara, las skills del Módulo 1 te ayudan a validar y estructurar todo.'
  }, {
    q: '¿Qué formato tiene el producto?',
    a: 'Es un archivo ZIP que descargás. Adentro tiene carpetas organizadas por módulo con archivos de texto. No es un video, no es un curso. Son herramientas que usás directamente.'
  }, {
    q: '¿Me sirve si vendo en Hotmart / Shopify / Gumroad?',
    a: 'Sí. Las skills son independientes de la plataforma. El copy, la estrategia, los ads y los emails funcionan igual sin importar dónde vendas.'
  }, {
    q: '¿Cuánto tiempo me ahorra realmente?',
    a: 'Escribir una landing completa: de 2 días a 30 minutos. Planificar un lanzamiento: 15 minutos. Crear 10 ángulos publicitarios con hooks: 10 minutos. No es magia, es tener las instrucciones correctas.'
  }, {
    q: '¿Y si no me gusta?',
    a: 'Tenés 45 días de garantía. Si no te sirve, te devuelvo el dinero. Sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 pb-32" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-37">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4 mb-16" data-id="element-38">
          {faqs.map((faq, index) => <div key={index} className="bg-white/5 border border-white/10 rounded-xl overflow-hidden backdrop-blur-sm" data-id="element-39">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-40">
                <span className="font-bold text-white text-lg pr-4" data-id="element-41">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#00B4D8] transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 py-4 border-t border-white/10' : 'max-h-0'}`} data-id="element-43">
                <p className="text-gray-300" data-id="element-44">{faq.a}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-45">
          <div className="mb-4" data-id="element-46">
            <span className="bg-[#E74C3C] text-white font-mono font-bold px-4 py-2 rounded-lg shadow-lg text-xl inline-block" data-id="element-47">
              <CountdownTimer data-id="element-48" />
            </span>
          </div>
          <button onClick={onCheckout} className="w-full md:w-auto bg-[#E74C3C] hover:bg-[#c0392b] text-white text-xl md:text-2xl font-bold py-6 px-10 rounded-xl shadow-[0_10px_20px_rgba(231,76,60,0.3)] hover:shadow-[0_15px_30px_rgba(231,76,60,0.4)] transition-all transform hover:-translate-y-1" data-id="element-49">
            ÚLTIMA OPORTUNIDAD — ACCEDER POR $19.800
          </button>
          <p className="text-gray-400 mt-4 font-medium" data-id="element-50">
            Descarga inmediata + Garantía 45 días + 4 bonos gratis
          </p>
        </div>
      </div>
    </section>;
}